import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import {
  ProductReport,
  MappingProductReportAttribute,
  MappingProductReportAttributeModel,
  ProductReportCategories,
  ProductReportStandardDictionary,
} from '../model/classes/productReport.class';
import { TemplateListadoItem } from '../model/classes/templateListadoItem.class';
import { EntityChildsContext } from 'app/private/entity/entityWithChilds/model/EntityChildsContext';

@Injectable()
export class ProductReportService {
  private serviceUrl = 'api/productReport';
  private subscriptionUrl = 'api/productReportSubscription';

  constructor(private http: Http, private sxHttp: SxHttpService) {}

  //#region Generals
  getAll(): Observable<ProductReport[]> {
    const url = `${this.serviceUrl}`;
    return this.sxHttp.get(url).map((response) => {
      const reports = response.json().data;
      return reports.map((report) => report as ProductReport);
    });
  }

  getTemplateList(systemCode: string, business: string, productCode: string): Observable<TemplateListadoItem[]> {
    const url = `${this.serviceUrl}/${systemCode}/${business}/${productCode}`;
    return this.sxHttp.get(url).map((response) => {
      const reports = response.json().data;
      return reports.map((report) => {
        return {
          id: report.id,
          imagen: null,
          titulo: report.description,
          subtitulo: null,
        };
      });
    });
  }

  get(id: string): Observable<ProductReport> {
    const url = `${this.serviceUrl}/${id}`;
    return this.sxHttp
      .get(url)
      .map((response) => response.json().data as ProductReport);
  }
  getCategories(): Observable<ProductReportCategories[]> {
    const url = `${this.serviceUrl}/getcategories`;
    return this.sxHttp
      .get(url)
      .map((response) => response.json().data as ProductReportCategories[]);
  }
  getStandardDictionary(): Observable<ProductReportStandardDictionary[]> {
    const url = `${this.serviceUrl}/getstandarddictionary`;
    return this.sxHttp
      .get(url)
      .map(
        (response) => response.json().data as ProductReportStandardDictionary[]
      );
  }
  create(report: ProductReport): Promise<ProductReport> {
    return this.sxHttp
      .post(this.serviceUrl, report)
      .toPromise()
      .then((response) => response.json().data as ProductReport);
  }
  createRule(productReport: ProductReport, ruleName: string): Promise<number> {
    const url = `${this.serviceUrl}/createrule/${ruleName}`;
    return this.sxHttp
      .post(url, productReport)
      .toPromise()
      .then((response) => response.json().data as number);
  }
  
  edit(report: ProductReport): Promise<ProductReport> {
    return this.sxHttp
      .put(this.serviceUrl, report)
      .toPromise()
      .then((response) => response.json().data as ProductReport);
  }

  delete(id: string): Promise<boolean> {
    const url = `${this.serviceUrl}/${id}`;
    return this.sxHttp
      .delete(url)
      .toPromise()
      .then((result) => result.json().data as boolean);
  }

  deleteRule(reportId: string, ruleId: string): Promise<Boolean> {
    const url = this.serviceUrl + `/deleterule/${reportId}/${ruleId}`;
    return this.sxHttp
      .delete(url)
      .toPromise()
      .then((response) => response.json().data as Boolean);
  }
  //#endregion

  //#region Attributes
  deleteAttribute(id: number): Promise<Boolean> {
    const url = this.serviceUrl + `/attribute/${id}`;
    return this.sxHttp
      .delete(url)
      .toPromise()
      .then((response) => response.json().data as Boolean);
  }

  getAttribute(
    productReportCode: string,
    mappingId: string
  ): Observable<MappingProductReportAttributeModel> {
    const url = `${this.serviceUrl}/attribute/${mappingId}`;
    return this.sxHttp
      .get(url)
      .map(
        (response) => response.json().data as MappingProductReportAttributeModel
      );
  }

  saveAttribute(
    attribute: MappingProductReportAttribute
  ): Promise<MappingProductReportAttributeModel> {
    const url = `${this.serviceUrl}/attribute`;
    return this.sxHttp
      .post(url, attribute)
      .toPromise()
      .then(
        (response) => response.json().data as MappingProductReportAttributeModel
      );
  }

  //#endregion

  //#region Product Report Subscriptions
  getAllWithContext(
    organizatinCode: string,
    subscriptionCode: string,
    channelCode: string,
    productCode: string
  ): Observable<ProductReport[]> {
    const context: EntityChildsContext = {
      organizationCode: organizatinCode,
      subscriptionCode: subscriptionCode,
      channelCode: channelCode,
      productCode,
    };
    return this.sxHttp
      .post(this.subscriptionUrl + '/GetProductReport', context)
      .map((response) => response.json().data as ProductReport[]);
  }

  getAllSubscribed(
    organizationCode: string,
    subscriptionCode: string,
    channelCode: string,
    productCode: string
  ): Observable<ProductReport[]> {
    let context: EntityChildsContext = {
      organizationCode: organizationCode,
      subscriptionCode: subscriptionCode,
      channelCode: channelCode,
      productCode: productCode,
    };
    return this.sxHttp
      .post(`${this.subscriptionUrl}/GetSubscription`, context)
      .map((response) => {
        return response.json().data as ProductReport[];
      });
  }

  productReportSubscription(productReportSubscription): Observable<Boolean> {
    return this.sxHttp
      .post(`${this.subscriptionUrl}/Subscription`, productReportSubscription)
      .map((response) => {
        return response.json().data;
      });
  }

  unsubscribe(
    idProductReport: string,
    organizationCode: string,
    subscriptionCode: string,
    channelCode: string,
    productCode: string
  ): Promise<Boolean> {
    let context: EntityChildsContext = {
      organizationCode: organizationCode,
      subscriptionCode: subscriptionCode,
      channelCode: channelCode,
      productCode: productCode,
    };
    return this.sxHttp
      .post(this.subscriptionUrl + '/Delete' + '/' + idProductReport, context)
      .toPromise()
      .then((result) => result.json().data);
  }
  //endregion
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/productreport.service.ts